import { render, staticRenderFns } from "./PixClipboardCopy.vue?vue&type=template&id=59012eab&"
import script from "./PixClipboardCopy.vue?vue&type=script&lang=js&"
export * from "./PixClipboardCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59012eab')) {
      api.createRecord('59012eab', component.options)
    } else {
      api.reload('59012eab', component.options)
    }
    module.hot.accept("./PixClipboardCopy.vue?vue&type=template&id=59012eab&", function () {
      api.rerender('59012eab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/OrderCreated/PixClipboardCopy.vue"
export default component.exports